import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Seo from "@/lib/seo";

export default function NotFound() {
  return (
    <>
      <Seo title="Page Not Found" description="The page you are looking for could not be found." path="/404" />
      <section className="relative flex min-h-screen items-center justify-center overflow-hidden bg-navy-deep">
        <div className="pointer-events-none absolute inset-0 bg-blueprint-dark opacity-40" />
        <div className="pointer-events-none absolute -left-20 top-20 h-80 w-80 rounded-full bg-brand/20 blur-[120px]" />
        <div className="container-sky relative text-center">
          <p className="font-heading text-[8rem] font-extrabold leading-none text-gradient-sky sm:text-[12rem]">404</p>
          <h1 className="mt-2 font-heading text-2xl font-bold text-white sm:text-3xl">Page Not Found</h1>
          <p className="mx-auto mt-4 max-w-md text-sm text-slate-300">
            The page you're looking for doesn't exist or has moved. Let's get you back on track.
          </p>
          <Link to="/" className="btn-primary-sky mt-8 !bg-white !text-navy hover:!bg-brand-light">
            <ArrowLeft className="h-4 w-4" /> Back to Home
          </Link>
        </div>
      </section>
    </>
  );
}
